import dayjs from "dayjs";
import { get, isString } from "lodash";
import moment from "moment";
import {
  MdNetworkPing,
  MdNumbers,
  MdOutlineBadge,
  MdOutlineCake,
  MdOutlineCall,
  MdOutlineHealthAndSafety,
  MdOutlineLocationOn,
  MdOutlineMediation,
  MdSearch,
  MdTripOrigin,
  MdWorkOutline,
} from "react-icons/md";
import { STEPS_KEYS } from "screens/Private/Broker/Clients/Create";
import Alert from "shared/components/Alert";
import Button from "shared/components/Button";
import Radio from "shared/components/Form/Radio";
import Input from "shared/components/Input";
import Switch from "shared/components/Input/Switch";
import Select from "shared/components/Select";
import {
  COMMUNICATION_CAMPAIGN_MEDIA,
  DATE_FORMAT,
  LMF_ASSOCIATION_MEMBER_TYPE,
  LMF_CONTACT_CANAL,
  LMF_ORIGINS,
  LMF_SOCIAL_REGIMES,
  PROFILE_LIST,
} from "utils/constants";
import { isMajor } from "utils/helpers/date";
import { bindDateInputProps, bindInputProps } from "utils/helpers/input";
export const step = { ADHERENT: "ADHERENT" };

const LMF_PROFILES = [
  PROFILE_LIST.PARTICULAR,
  PROFILE_LIST.TNS,
  PROFILE_LIST.TERRITORIAL_AGENT,
  PROFILE_LIST.THIS_FAMILY,
  PROFILE_LIST.C2SP,
  PROFILE_LIST.C2S_EXIT_CONTRACT,
  PROFILE_LIST.ASSOCIATION_MEMBER,
];

const LMF_SUB_PROFILES = [
  LMF_ASSOCIATION_MEMBER_TYPE.RETIREMENT_SOLIDARITY_LEISURE,
  LMF_ASSOCIATION_MEMBER_TYPE.RETIREMENT_SPORTS,
];

const REGIMES_SWITCH_PROFILE = {
  [PROFILE_LIST.PARTICULAR]: [
    LMF_SOCIAL_REGIMES.SECURITE_SOCIALE,
    LMF_SOCIAL_REGIMES.ALSACE_MOSELLE,
    LMF_SOCIAL_REGIMES.MINIER,
    LMF_SOCIAL_REGIMES.REGIME_SALARIES_AGRICOLES,
  ],
  [PROFILE_LIST.TERRITORIAL_AGENT]: [
    LMF_SOCIAL_REGIMES.SECURITE_SOCIALE,
    LMF_SOCIAL_REGIMES.ALSACE_MOSELLE,
  ],
  [PROFILE_LIST.TNS]: [
    LMF_SOCIAL_REGIMES.SECURITE_SOCIALE,
    LMF_SOCIAL_REGIMES.ALSACE_MOSELLE,
  ],
  [PROFILE_LIST.ASSOCIATION_MEMBER]: [
    LMF_SOCIAL_REGIMES.SECURITE_SOCIALE,
    LMF_SOCIAL_REGIMES.ALSACE_MOSELLE,
  ],
  [PROFILE_LIST.C2SP]: [
    LMF_SOCIAL_REGIMES.SECURITE_SOCIALE,
    LMF_SOCIAL_REGIMES.ALSACE_MOSELLE,
  ],
  [PROFILE_LIST.C2S_EXIT_CONTRACT]: [
    LMF_SOCIAL_REGIMES.SECURITE_SOCIALE,
    LMF_SOCIAL_REGIMES.ALSACE_MOSELLE,
  ],
  [PROFILE_LIST.THIS_FAMILY]: [
    LMF_SOCIAL_REGIMES.SECURITE_SOCIALE,
    LMF_SOCIAL_REGIMES.ALSACE_MOSELLE,
  ],
};

const Adherent = ({
  index,
  translation,
  values,
  setFieldValue,
  projectId,
  graOptions,
  graLoading,
  onSearchGRA,
  onClearGRA,
  ...formProps
}) => {
  const { handleChange } = formProps;
  const birthDate = get(values, "contact.user.birthDate");
  const parsedDate = isString(birthDate) ? moment(birthDate) : birthDate;
  const graTranslation =
    translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM.GRA_CODE;
  return (
    <div className="contact-stepper" key={step.ADHERENT}>
      <div className="contact-stepper__header">
        <div className="contact-stepper__header--counter">
          <span>{index}</span>
        </div>
        <div className="contact-stepper__header--content">
          <h1 className="contact-stepper__header--content--title">
            <span>
              {translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].TITLE}
            </span>
          </h1>
          <p className="contact-stepper__header--content--description">
            {translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].DESCRIPTION}
          </p>
        </div>
      </div>
      <div className="contact-stepper__content">
        <Radio
          label={
            translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM.CIVILITY
              .LABEL
          }
          options={[
            {
              label:
                translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM.CIVILITY
                  .MALE,
              value: "M",
            },
            {
              label:
                translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM.CIVILITY
                  .FEMALE,
              value: "F",
            },
          ]}
          icon={<MdOutlineBadge size={22} />}
          {...bindInputProps({
            name: "contact.user.gender",
            values,
            ...formProps,
          })}
        />
        <Input
          label={
            translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM.LASTNAME
              .LABEL
          }
          icon={<MdOutlineBadge size={22} />}
          placeholder={
            translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM.LASTNAME
              .PLACEHOLDER
          }
          {...bindInputProps({
            name: "contact.user.lastname",
            values,
            ...formProps,
          })}
          onChange={(e) => {
            handleChange("contact.user.lastname")(e);
            onClearGRA();
          }}
        />
        <Input
          label={
            translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM.FIRSTNAME
              .LABEL
          }
          icon={<MdOutlineBadge size={22} />}
          placeholder={
            translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM.FIRSTNAME
              .PLACEHOLDER
          }
          {...bindInputProps({
            name: "contact.user.firstname",
            values,
            ...formProps,
          })}
          onChange={(e) => {
            handleChange("contact.user.firstname")(e);
            onClearGRA();
          }}
        />
        <Input
          icon={<MdOutlineCake size={22} />}
          label={
            translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM.BIRTHDAY
              .LABEL
          }
          placeholder={
            translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM.BIRTHDAY
              .PLACEHOLDER
          }
          type="date"
          variant="simple"
          format={DATE_FORMAT}
          disabledDate={(current) =>
            current > moment().subtract(16, "years").endOf("day")
          }
          defaultPickerValue={
            !get(values, "contact.user.birthDate") &&
            dayjs().subtract(30, "years")
          }
          {...bindDateInputProps({
            name: "contact.user.birthDate",
            values,
            setFieldValue,
            ...formProps,
          })}
          onChange={(date, dateString) => {
            setFieldValue(
              "contact.user.birthDate",
              date ? date.format("YYYY-MM-DD") : null,
            );
            onClearGRA();
          }}
        />

        {parsedDate?.endOf("day") > isMajor && (
          <Alert
            message={
              translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM.LMF_ALERT
            }
          />
        )}
        <div className="d-flex gap-8 align--end">
          <div className="flex--grow-1">
            <Select
              icon={<MdNumbers size={22} />}
              options={graOptions.map((result) => ({
                value: result.graCode,
                label: `${result.graCode}`,
              }))}
              placeholder={graTranslation.PLACEHOLDER}
              label={graTranslation.LABEL}
              loading={graLoading}
              {...bindInputProps({
                name: "fields.graCode",
                values,
                ...formProps,
              })}
              onChange={(value) => {
                setFieldValue("fields.graCode", value);
              }}
            />
          </div>
          <Button
            type="primary"
            onClick={() => onSearchGRA()}
            loading={graLoading}
          >
            <MdSearch size={16} />
            {graTranslation.SEARCH}
          </Button>
        </div>
        <Input
          icon={<MdOutlineLocationOn size={22} />}
          placeholder={
            translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
              .ZIPCODE.PLACEHOLDER
          }
          label={
            translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
              .ZIPCODE.LABEL
          }
          {...bindInputProps({
            name: "zipCode.value",
            values,
            ...formProps,
          })}
        />
        <Input
          icon={<MdOutlineCall size={16} />}
          type="phone"
          inputMode="numeric"
          maxLength={10}
          placeholder={
            translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM.PHONE
              .PLACEHOLDER
          }
          label={
            translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM.PHONE
              .LABEL
          }
          {...bindInputProps({
            name: "phoneNumber.value",
            values,
            ...formProps,
          })}
        />
        <Select
          icon={<MdOutlineHealthAndSafety size={22} />}
          options={get(
            REGIMES_SWITCH_PROFILE,
            get(values, "contact.fields.profile"),
            Object.values(LMF_SOCIAL_REGIMES),
          ).map((value) => {
            const key = Object.keys(LMF_SOCIAL_REGIMES).find(
              (k) => LMF_SOCIAL_REGIMES[k] === value,
            );
            return {
              value,
              label: translation.LMF_SOCIAL_REGIMES[key],
            };
          })}
          placeholder={
            translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
              .SOCIAL_REGIME.PLACEHOLDER
          }
          label={
            translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
              .SOCIAL_REGIME.LABEL
          }
          {...bindInputProps({
            name: "contact.socialRegime",
            values,
            ...formProps,
          })}
        />
        <Select
          showSearch
          icon={<MdWorkOutline size={16} />}
          options={LMF_PROFILES.map((value) => ({
            value,
            label:
              translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
                .PROFILES.OPTIONS[value],
          })).sort((a, b) => get(a, "label", "").localeCompare(b.label))}
          label={
            translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
              .PROFILE.LABEL
          }
          placeholder={
            translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
              .PROFILE.PLACEHOLDER
          }
          {...bindInputProps({
            name: "contact.fields.profile",
            values,
            ...formProps,
          })}
          onChange={(value) => {
            setFieldValue("contact.fields.profile", value);
            setFieldValue("contact.fields.associationMemberType", undefined);

            const currentRegime = get(values, "contact.socialRegime");
            const availableRegimes = get(
              REGIMES_SWITCH_PROFILE,
              value,
              Object.values(LMF_SOCIAL_REGIMES),
            );

            if (currentRegime && !availableRegimes.includes(currentRegime)) {
              setFieldValue("contact.socialRegime", undefined);
            }

            if (availableRegimes.length === 1) {
              setFieldValue("contact.socialRegime", availableRegimes[0]);
            }
          }}
        />
        {get(values, "contact.fields.profile") ===
          PROFILE_LIST.ASSOCIATION_MEMBER && (
          <Select
            showSearch
            icon={<MdWorkOutline size={16} />}
            options={LMF_SUB_PROFILES.map((value) => ({
              value,
              label: translation.LMF_ASSOCIATION_MEMBER_TYPE[value],
            })).sort((a, b) => get(a, "label", "").localeCompare(b.label))}
            label={
              translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
                .SUB_PROFILE.LABEL
            }
            placeholder={
              translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
                .SUB_PROFILE.PLACEHOLDER
            }
            {...bindInputProps({
              name: "contact.fields.subProfile",
              values,
              ...formProps,
            })}
          />
        )}
        <div className="contact-stepper__content--radio">
          <span className="contact-stepper__content--radio--title flex--grow-1">
            {
              translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
                .IS_LMF_CLIENT
            }
          </span>
          <Switch
            className="contact-stepper__content--radio--switch button__switch"
            checkedChildren={
              translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
                .OPTIONS.YES
            }
            unCheckedChildren={
              translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
                .OPTIONS.NO
            }
            defaultChecked={get(values, "contact.fields.isClient")}
            onChange={(value, _) => {
              setFieldValue("contact.fields.isClient", value);
            }}
          />
        </div>
        <div className="contact-stepper__content--radio">
          <span className="contact-stepper__content--radio--title flex--grow-1">
            {
              translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
                .IS_C2S
            }
          </span>
          <Switch
            className="contact-stepper__content--radio--switch button__switch "
            checkedChildren={
              translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
                .OPTIONS.YES
            }
            unCheckedChildren={
              translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
                .OPTIONS.NO
            }
            defaultChecked={get(values, "fields.info.cssBeneficiary")}
            onChange={(value, _) => {
              setFieldValue("fields.info.cssBeneficiary", value);
            }}
          />
        </div>
        <Select
          showSearch
          icon={<MdTripOrigin size={16} />}
          options={Object.entries(LMF_ORIGINS).map(([key, value]) => ({
            value,
            label: translation.LMF_ORIGINS[key],
          }))}
          label={
            translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM.ORIGIN
              .LABEL
          }
          placeholder={
            translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM.ORIGIN
              .PLACEHOLDER
          }
          {...bindInputProps({
            name: "contact.fields.membershipOrigin",
            values,
            ...formProps,
          })}
          onChange={(value) => {
            setFieldValue("contact.fields.membershipOrigin", value);
            setFieldValue("contact.fields.membershipSubOrigin", undefined);
          }}
        />
        {get(values, "contact.fields.membershipOrigin") ===
          LMF_ORIGINS.COMMUNICATION_CAMPAIGN && (
          <Select
            showSearch
            icon={<MdNetworkPing size={16} />}
            options={Object.entries(COMMUNICATION_CAMPAIGN_MEDIA).map(
              ([key, value]) => ({
                value,
                label: translation.COMMUNICATION_CAMPAIGN_MEDIA[key],
              }),
            )}
            label={
              translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
                .COMMUNICATION_CAMPAIGN.LABEL
            }
            placeholder={
              translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
                .COMMUNICATION_CAMPAIGN.PLACEHOLDER
            }
            {...bindInputProps({
              name: "contact.fields.membershipSubOrigin",
              values,
              ...formProps,
            })}
          />
        )}
        <Select
          showSearch
          icon={<MdOutlineMediation size={16} />}
          options={Object.entries(LMF_CONTACT_CANAL).map(([key, value]) => ({
            value,
            label: translation.LMF_CONTACT_CANAL[key],
          }))}
          label={
            translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
              .CONTACT_CANAL.LABEL
          }
          placeholder={
            translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
              .CONTACT_CANAL.PLACEHOLDER
          }
          {...bindInputProps({
            name: "contact.fields.contactCanal",
            values,
            ...formProps,
          })}
        />
      </div>
    </div>
  );
};
export default Adherent;
